export enum FieldFormatType {
  NUMERICAL,
  CPF,
  CNPJ,
  TELEPHONE,
  ZIPCODE,
  CURRENCY,
}
